"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var createTag = function createTag(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    title: (0, _utils.getProp)(fields, 'title'),
    icon: (0, _utils.getProp)(fields, 'icon')
  };
};
var _default = createTag;
exports["default"] = _default;